import { useBaseQuery } from '@aibees/shared/http/hooks';
import { urlMock } from '@aibees/shared/utils';
import { RecommendationsItem } from './types';

interface RecommendationsResponse {
  content: RecommendationsItem[];
}

export function useGetRecommendationsApi() {
  return useBaseQuery<never, RecommendationsResponse>([], {
    url: urlMock('recommendations'),
  });
}
